import React, { useEffect, useState } from 'react';
import { apis, hooks, models } from "@vote4dance/judging-sdk";
import { App, Table, Spin, Select, Dropdown, Button, notification, Typography, Grid, Badge, Tooltip, Skeleton, theme, Space, Divider } from 'antd';
import { _T } from "../../../../../base-react/src/Localization";
import { ArrowRightOutlined, CheckOutlined, CommentOutlined, CrownFilled, CrownOutlined, DeleteOutlined, EyeOutlined, FilterOutlined, HeartFilled, LockFilled, MoreOutlined, StopOutlined, UnlockOutlined, UserAddOutlined, UserDeleteOutlined, WarningOutlined } from '@ant-design/icons';
import { RoundGroupSummary, RoundPointSummary, RoundPointSummaryEdit, RoundResultSummary, RoundResultValue } from './RoundResultValue';
import { RoundPriorityType } from '@vote4dance/judging-types';
import { JudgeType, JudgingType, RoundStatus, RoundType } from '@vote4dance/judging-schema';
var Api = apis.Api;
var Stream = hooks.streams.Stream;
var RoundJudgeSource = models.judges.RoundJudgeSource;
var ClassRoundSource = models.rounds.ClassRoundSource;
var RoundStateSource = models.results.RoundStateSource;
var HeatSource = models.heats.HeatSource;
var HeatsTeamSource = models.teams.HeatsTeamSource;
var JudgeItem = models.judges.JudgeItem;
var RoundItem = models.rounds.RoundItem;
var RoundReceiptSource = models.rounds.RoundReceiptSource;
var ClassesSource = models.classes.ClassesSource;
var RoundVotesSource = models.votes.RoundVotesSource;
import { Link as LinkTo, useParams } from 'react-router-dom';
import { HeatsTeamItem } from '../../../../../base-react/models/teams';
import { RoundResultFooterSummary } from './RoundResultFooterSummary';
import { useCompetition } from '../../../../../base-react/hooks/Competition';
import { chunkArray } from '../utilities';
import { getActiveApplicationBatteryLevels, getActiveApplicationUserIds, getApplicationStatusTitle } from '../../../../components/ApplicationStatusDot';
const { useBreakpoint } = Grid;
const { Text } = Typography;
const { useToken } = theme;
export const RoundResultHeat = (props) => {
    const { class_id, round, heat, heats, judging, disabled, showStatistics, extraFields, onClickExtraField } = props;
    const { modal } = App.useApp();
    const heatSource = HeatSource(round.round_id);
    const heatsTeamSource = HeatsTeamSource(round.round_id, heat.heat_number);
    const roundReceiptSource = RoundReceiptSource(round.round_id);
    const [inputCompetition, event] = useCompetition(round.competition_id);
    const votingEnabled = Number(event === null || event === void 0 ? void 0 : event.competition_voting_enabled) === 1;
    const [votes, loadingVotes] = Stream(votingEnabled ? RoundVotesSource(round.round_id) : undefined);
    const [judges, loadingJudges] = Stream(RoundJudgeSource(round.competition_id, round.round_id));
    const [teams, loadingTeams] = Stream(heatsTeamSource);
    const [rounds, loadingRounds] = Stream(ClassRoundSource(class_id));
    const [states, loadingStates] = Stream((RoundItem.isPointSummary(round) || round.judging_type === JudgingType.Ajs) ? RoundStateSource(round.round_id) : undefined);
    const [receipts, loadingReceipts] = Stream(roundReceiptSource);
    const [classes, loadingClasses] = Stream(ClassesSource(round.competition_id));
    const [teamLoading, setTeamLoading] = useState({});
    const [heatDone, setHeatDone] = useState(heat.heat_done > 0);
    const screens = useBreakpoint();
    const { token } = useToken();
    let { event_id } = useParams();
    const [applications] = Stream(event_id ? models.applications.CompetitionApplicationsSource(event_id) : undefined);
    const isClosed = [RoundStatus.Closed, RoundStatus.Confirmed].includes(round.round_status);
    const activeJudgeUserIds = React.useMemo(() => getActiveApplicationUserIds(applications, 'judging'), [applications]);
    const activeJudgeBatteryLevels = React.useMemo(() => getActiveApplicationBatteryLevels(applications, 'judging'), [applications]);
    const normalizeRemarkState = (remark) => {
        if (typeof remark === 'string') {
            return remark.toLowerCase().trim();
        }
        if (Array.isArray(remark)) {
            const firstString = remark.find(value => typeof value === 'string' && value.trim().length > 0);
            return firstString ? firstString.toLowerCase().trim() : '';
        }
        return '';
    };
    const getRemarkStateLabel = (remark) => {
        const normalized = normalizeRemarkState(remark);
        if (!normalized) {
            return '';
        }
        const key = `remark.state.${normalized}`;
        const value = _T(key);
        return value === key ? normalized.toUpperCase() : value;
    };
    const getRemarkStateHint = (remark) => {
        const normalized = normalizeRemarkState(remark);
        if (!normalized) {
            return '';
        }
        const key = `remark.state.${normalized}-hint`;
        const value = _T(key);
        return value === key ? '' : value;
    };
    const toFindDuplicates = (array) => array && array.filter((item, index) => array.indexOf(item) !== index);
    const updatedTeams = React.useMemo(() => {
        if (!teams) {
            return [];
        }
        const sharedPlacements = toFindDuplicates(round && round.round_skating && round.round_skating.map((team) => parseInt(team.position)));
        const sharedTeams = round && round.round_skating
            && round.round_skating.filter((a) => a.teams.length > 1).map((a) => a.teams).flat();
        return teams.map((team) => {
            const hasSharedPlacement = (sharedTeams && sharedTeams.includes(team.heats_team_id))
                || (sharedPlacements && sharedPlacements.includes(team.heats_team_placement));
            return {
                ...team,
                hasSharedPlacement,
                loading: teamLoading[String(team.heats_team_id)]
            };
        });
    }, [teams, teamLoading, round.round_skating]);
    useEffect(() => {
        const nextHeatDone = heat.heat_done > 0;
        setHeatDone((prev) => (prev === nextHeatDone ? prev : nextHeatDone));
    }, [heat.heat_done]);
    if (loadingTeams || loadingJudges || loadingRounds || loadingStates || loadingReceipts || loadingClasses) {
        return React.createElement(Skeleton, null);
    }
    const throughRounds = rounds && rounds.filter((a) => a.round_type == RoundType.Chance ||
        parseInt(a.round_parent_id) == 0 &&
            a.round_id != round.round_id);
    const childRounds = rounds === null || rounds === void 0 ? void 0 : rounds.filter((a) => a.round_parent_id === round.round_id);
    const hasChildRounds = RoundItem.isShared(round);
    const prioritySettings = RoundItem.getPrioritySettings(round);
    const getPointSummaryRounds = () => {
        if (states && states.length > 0) {
            const data = states[0].state_data;
            return data.judges;
        }
        return [];
    };
    const getGroupedClasses = () => {
        if (classes) {
            return classes.filter(a => a.class_group_id === round.class_id);
        }
        return [];
    };
    const getVotingPoints = (id, votes) => {
        let totalPoints = 0;
        votes && votes.forEach((row) => {
            if (!row.vote_results)
                return;
            try {
                const voteList = JSON.parse(row.vote_results);
                voteList.forEach(({ heats_team_id, result_rating }) => {
                    if (heats_team_id === id) {
                        totalPoints += result_rating;
                    }
                });
            }
            catch (error) {
                console.error('Invalid JSON in vote_results:', row.vote_results, error);
            }
        });
        return totalPoints || null;
    };
    const setItemLoading = (item, loading) => {
        const key = String(item.heats_team_id);
        setTeamLoading((prev) => {
            if (prev[key] === loading) {
                return prev;
            }
            if (!loading) {
                const { [key]: _unused, ...rest } = prev;
                return rest;
            }
            return { ...prev, [key]: loading };
        });
    };
    const changeHeat = (item, targetHeatNumber) => {
        setItemLoading(item, true);
        Api.call(`${heatSource.url}/${targetHeatNumber}`, "save-order", { order: [item.heats_team_id] })
            .then(() => {
            setItemLoading(item, false);
        })
            .catch((err) => {
            notification.error({
                message: err.name
            });
            setItemLoading(item, false);
        });
    };
    const cancelTeam = (item, value) => {
        setItemLoading(item, true);
        Api.call(`${heatsTeamSource.url}/${item.heats_team_id}`, value ? "cancel-team" : "uncancel-team")
            .then(() => {
            setItemLoading(item, false);
        })
            .catch((err) => {
            notification.error({
                message: err.name
            });
            setItemLoading(item, false);
        });
    };
    const deleteTeam = (item) => {
        modal.confirm({
            title: _T('common.delete.title', { name: _T('team.title').toLowerCase() }),
            content: _T('common.delete.content', { name: HeatsTeamItem.getFullName(item) }),
            onOk() {
                setItemLoading(item, true);
                Api.destroy(`${heatsTeamSource.url}/${item.heats_team_id}`)
                    .then(() => {
                    setItemLoading(item, false);
                })
                    .catch((err) => {
                    notification.error({
                        message: err.name
                    });
                    setItemLoading(item, false);
                });
            }
        });
    };
    const changeClass = (item, class_id) => {
        setItemLoading(item, true);
        Api.call(`${heatsTeamSource.url}/${item.heats_team_id}`, "change-class", { class_id })
            .then(() => {
            setItemLoading(item, false);
        })
            .catch((err) => {
            notification.error({
                message: _T(err.response.message)
            });
            setItemLoading(item, false);
        });
    };
    const heatsTeamMenuItems = (item) => [
        heats.length > 1 ?
            {
                label: _T('round.changeHeat'),
                key: `${item.heats_team_id}/heat`,
                icon: React.createElement(ArrowRightOutlined, null),
                children: heats.map(a => ({
                    label: _T('round.heat', { number: a.heat_number.toString() }),
                    key: `${item.heats_team_id}/heat/${a.heat_number}`,
                    disabled: a.heat_number == item.heat_number
                }))
            } : null,
        {
            label: _T('round.changeClass.title'),
            key: `${item.heats_team_id}/class`,
            icon: React.createElement(ArrowRightOutlined, null),
            disabled: parseInt(item.heats_team_target_id) > 0 || parseInt(item.heats_team_source_id) > 0,
            children: (() => {
                if (classes && classes.length > 20) {
                    const classChunks = chunkArray(classes, 20);
                    return classChunks.map((chunk, index) => {
                        const start = index * 20 + 1;
                        const end = (index + 1) * 20;
                        return {
                            key: `${item.heats_team_id}/submenu/${index + 1}`,
                            label: `${start}-${end}`,
                            children: chunk.map(a => ({
                                label: a.class_label || a.class_name,
                                key: `${item.heats_team_id}/class/${a.class_id}`,
                                disabled: a.class_id === round.class_id,
                            })),
                        };
                    });
                }
                else {
                    return classes === null || classes === void 0 ? void 0 : classes.map(a => ({
                        label: a.class_label || a.class_name,
                        key: `${item.heats_team_id}/class/${a.class_id}`,
                        disabled: a.class_id === round.class_id,
                    }));
                }
            })()
        },
        item.team_cancelled ?
            {
                label: _T('team.undoCancel'),
                key: `${item.heats_team_id}/undoCancel`,
                icon: React.createElement(UserAddOutlined, null),
            } :
            {
                label: _T('team.cancel'),
                key: `${item.heats_team_id}/cancel`,
                icon: React.createElement(UserDeleteOutlined, null),
                danger: true
            },
        {
            label: _T('common.delete.title'),
            key: `${item.heats_team_id}/delete`,
            icon: React.createElement(DeleteOutlined, null),
            danger: true
        }
    ];
    const onClickHeatsTeamMenuItem = (e) => {
        const params = e.key.split('/');
        const idParam = params[0];
        const actionParam = params[1];
        const extraParam = params[2];
        const foundTeam = updatedTeams.find(a => a.heats_team_id == idParam);
        if (!foundTeam) {
            return;
        }
        switch (actionParam) {
            case 'heat': return changeHeat(foundTeam, parseInt(extraParam));
            case 'undoCancel': return cancelTeam(foundTeam, false);
            case 'cancel': return cancelTeam(foundTeam, true);
            case 'class': return changeClass(foundTeam, extraParam);
            case 'delete': return deleteTeam(foundTeam);
        }
    };
    const judgeLetterMenuItems = (item) => {
        const foundJudge = judges && judges.find((judge) => judge.judge_id == item.judge_id);
        if (!foundJudge) {
            return [{
                    label: item.judge_letter,
                    key: item.judge_id
                }];
        }
        if (judgeHasSubmitted(foundJudge)) {
            return [{
                    label: JudgeItem.getFullName(foundJudge),
                    key: `${foundJudge.judge_id}/unlock`,
                    icon: React.createElement(UnlockOutlined, null),
                }];
        }
        else {
            return [{
                    label: JudgeItem.getFullName(foundJudge),
                    key: `${foundJudge.judge_id}/lock`,
                    icon: React.createElement(LockFilled, null),
                }];
        }
    };
    const onClickJudgeLetterMenuItem = (e) => {
        const params = e.key.split('/');
        const idParam = params[0];
        const actionParam = params[1];
        const foundJudge = judges && judges.find((judge) => judge.judge_id == idParam);
        if (!foundJudge) {
            return;
        }
        const lockReceipt = (item) => {
            Api.update(`${roundReceiptSource.url}/${item.judge_id}`, { judge_id: item.judge_id })
                .catch((err) => {
                notification.error({
                    message: err.name
                });
            });
        };
        const unlockReceipt = (item) => {
            Api.destroy(`${roundReceiptSource.url}/${item.judge_id}`)
                .catch((err) => {
                notification.error({
                    message: err.name
                });
            });
        };
        switch (actionParam) {
            case 'lock': return lockReceipt(foundJudge);
            case 'unlock': return unlockReceipt(foundJudge);
        }
    };
    const judgeHasSubmitted = (item) => {
        const foundReceipt = receipts && receipts.find((receipt) => (receipt.judge_id == item.judge_id));
        const heatLock = round.round_heat_lock > 0;
        if (heatLock && foundReceipt) {
            const lockedHeats = foundReceipt.receipt_heats;
            if (lockedHeats == null) {
                return true;
            }
            else {
                const lockedHeatData = JSON.parse(lockedHeats);
                if (lockedHeatData.locked) {
                    return lockedHeatData.locked.includes(heat.heat_number);
                }
                else {
                    return false;
                }
            }
        }
        else {
            return !!foundReceipt;
        }
    };
    const onChangeAttribute = (item, value, attribute) => {
        setItemLoading(item, true);
        const oldValue = item[attribute];
        item[attribute] = value;
        Api.update(`${heatsTeamSource.url}/${item.heats_team_id}`, item)
            .then(() => {
            setItemLoading(item, false);
        })
            .catch((err) => {
            item[attribute] = oldValue;
            setItemLoading(item, false);
            notification.error({
                message: err.name
            });
        });
    };
    const onToggleHeatDone = () => {
        const oldValue = heatDone;
        const newItem = {
            ...heat,
            heat_done: heatDone ? 0 : 1
        };
        setHeatDone(!heatDone);
        Api.update(`${heatSource.url}/${heat.heat_number}`, newItem)
            .then(() => {
        })
            .catch((err) => {
            setHeatDone(oldValue);
            notification.error({
                message: err.name
            });
        });
    };
    const extraColumnKeys = ['team_org', 'team_country', 'team_show_name'];
    const items = extraColumnKeys.map(field => ({
        key: field,
        label: _T(`team.details.${field}.label`),
    }));
    const onClickExtraFieldsMenuItem = (e) => {
        onClickExtraField(e.key);
    };
    const visibleJudges = judges === null || judges === void 0 ? void 0 : judges.filter((judge) => judge.judge_type !== JudgeType.Trainee);
    const selectColumnWidth = 150;
    const visibleExtraColumnCount = extraColumnKeys.filter(field => extraFields.includes(field)).length;
    const showVotesColumn = votingEnabled && !!votes && votes.length > 0;
    const judgeColumnOffset = (screens.md ? 2 : 1) + visibleExtraColumnCount + (showVotesColumn ? 1 : 0);
    const renderJudgeConnectivityDot = (judge) => {
        const isConnected = activeJudgeUserIds.has(String(judge.user_id));
        const batteryLevel = activeJudgeBatteryLevels.get(String(judge.user_id));
        const hasBattery = typeof batteryLevel === 'number';
        const dotColor = !isConnected
            ? token.colorTextQuaternary
            : (hasBattery && batteryLevel <= 20)
                ? token.colorError
                : token.colorSuccess;
        const w = 8, bodyH = 11, capH = 2;
        const fillH = hasBattery ? Math.round((batteryLevel / 100) * (bodyH - 2)) : (isConnected ? bodyH - 2 : 0);
        return (React.createElement(Tooltip, { title: getApplicationStatusTitle(isConnected, batteryLevel) },
            React.createElement("span", { style: { position: 'absolute', top: -4, right: -18, lineHeight: 0, boxShadow: `0 0 0 1px ${token.colorBgContainer}`, borderRadius: 2 } }, hasBattery ? (React.createElement("svg", { width: w, height: bodyH + capH + 1, viewBox: `0 0 ${w} ${bodyH + capH + 1}`, style: { display: 'block' } },
                React.createElement("rect", { x: 2, y: 0, width: w - 4, height: capH, rx: 1, fill: dotColor }),
                React.createElement("rect", { x: 0, y: capH, width: w, height: bodyH, rx: 1.5, fill: "none", stroke: dotColor, strokeWidth: 1 }),
                React.createElement("rect", { x: 1.5, y: capH + 1 + (bodyH - 2 - fillH), width: w - 3, height: Math.max(0, fillH), rx: 0.5, fill: dotColor }))) : (React.createElement("span", { style: { display: 'inline-block', width: 8, height: 8, borderRadius: '50%', backgroundColor: dotColor } })))));
    };
    const columns = [
        {
            dataIndex: 'sort',
            width: 30,
            fixed: 'left',
            title: () => (React.createElement(Tooltip, { title: _T('round.toggleHeat') },
                React.createElement(Button, { size: "small", onClick: onToggleHeatDone, type: heatDone ? "primary" : "default", disabled: isClosed || disabled },
                    React.createElement(CheckOutlined, null)))),
            render: (text, item) => (item.loading ? React.createElement(Spin, null) : (React.createElement(Dropdown, { disabled: isClosed || disabled, menu: {
                    items: heatsTeamMenuItems(item),
                    onClick: onClickHeatsTeamMenuItem
                } },
                React.createElement(Button, { size: "small" },
                    React.createElement(MoreOutlined, null))))),
            responsive: ['md']
        },
        {
            title: React.createElement(Space, null,
                React.createElement(Dropdown, { menu: {
                        items,
                        selectable: true,
                        selectedKeys: extraFields,
                        onClick: onClickExtraFieldsMenuItem
                    } },
                    React.createElement(Button, { icon: React.createElement(FilterOutlined, null), size: 'small' })),
                React.createElement(Badge, { count: teams === null || teams === void 0 ? void 0 : teams.filter(a => a.heat_number == heat.heat_number && !a.team_cancelled).length, offset: [15, 0] }, _T('round.heat', { number: heat.heat_number.toString() }))),
            fixed: 'left',
            dataIndex: 'team_start_number',
            render: (text, item) => (React.createElement(Tooltip, { placement: "right", title: React.createElement(Space, { separator: React.createElement(Divider, { orientation: "vertical" }) },
                    React.createElement(React.Fragment, null, HeatsTeamItem.getFullName(item)),
                    item.team_org &&
                        React.createElement(React.Fragment, null, item.team_org),
                    item.team_country &&
                        React.createElement(React.Fragment, null, item.team_country)) },
                React.createElement(Space, null,
                    React.createElement(LinkTo, { to: `/event/${event_id}/comp/${round.competition_id}/teams/${item.team_id}` },
                        React.createElement(Text, { style: { color: token.colorPrimary, textDecoration: (item.team_disqualified > 0 || item.team_cancelled > 0) ? 'line-through' : undefined } }, parseInt(text) > 0 ? text : HeatsTeamItem.getFullName(item))),
                    item.team_disqualified > 0 &&
                        React.createElement(Tooltip, { title: _T('team.details.team_disqualified.label') },
                            React.createElement(StopOutlined, null)),
                    item.heats_team_ready > 0 &&
                        React.createElement(Badge, { status: "success" }),
                    item.team_warning &&
                        React.createElement(Tooltip, { title: item.team_warning },
                            React.createElement(WarningOutlined, null)),
                    item.team_note &&
                        React.createElement(Tooltip, { title: item.team_note },
                            React.createElement(CommentOutlined, null)))))
        },
        extraColumnKeys.map(field => ({
            title: _T(`team.details.${field}.label`),
            dataIndex: field,
            key: field,
            hidden: !extraFields.includes(field)
        })),
        showVotesColumn ?
            {
                title: React.createElement(Tooltip, { title: _T('voting.title') },
                    React.createElement(HeartFilled, null)),
                render: (text, item) => (loadingVotes ? React.createElement(Spin, null) : getVotingPoints(item.heats_team_id, votes))
            } : {},
        RoundItem.isPointSummary(round) ? [
            ...getPointSummaryRounds().map((label) => ({
                title: () => {
                    const key = 'round.state.' + label;
                    const translated = _T(key);
                    if (translated === key) {
                        return label;
                    }
                    return translated;
                },
                render: (text, item) => (React.createElement(RoundPointSummary, { team: item, label: label, states: states }))
            })),
            {
                title: _T('round.details.round_priority_settings.group.multiplier'),
                render: (text, item) => (React.createElement(RoundPointSummary, { team: item, label: 'multiplier', states: states }))
            },
            {
                render: (text, item) => (React.createElement(RoundPointSummaryEdit, { team: item, disabled: disabled }))
            },
            {
                dataIndex: 'heats_team_target_usermodified',
                render: (text) => (parseInt(text) > 0 &&
                    React.createElement(Tooltip, { title: _T('round.sendTeams.through.modified') },
                        React.createElement("div", { style: { textAlign: 'center' } },
                            React.createElement(WarningOutlined, { style: { color: token.colorWarning, fontSize: 21 } })))),
            },
        ] : round.class_group_count > 0 ?
            getGroupedClasses().map(classItem => ({
                title: () => classItem.class_name,
                render: (text, item) => (React.createElement(RoundGroupSummary, { team: item, classItem: classItem }))
            }))
            : hasChildRounds ? childRounds === null || childRounds === void 0 ? void 0 : childRounds.map((childRound) => ({
                title: () => React.createElement(LinkTo, { to: `/event/${event_id}/comp/${childRound.competition_id}/classes/${childRound.class_id}/${childRound.round_id}` }, childRound.round_label),
                render: (text, item) => (React.createElement(RoundResultSummary, { round: childRound, team_id: item.team_id, judging: judging }))
            })) : visibleJudges === null || visibleJudges === void 0 ? void 0 : visibleJudges.map((judge) => ({
                title: () => screens.md ? (React.createElement(Dropdown, { disabled: isClosed || disabled, menu: {
                        items: judgeLetterMenuItems(judge),
                        onClick: onClickJudgeLetterMenuItem
                    } },
                    React.createElement(Button, { size: "small", type: judgeHasSubmitted(judge) ? "primary" : "default" },
                        judge.judge_letter,
                        ' ',
                        React.createElement("span", { style: { position: 'relative', display: 'inline-flex', alignItems: 'center' } },
                            judgeHasSubmitted(judge) ? React.createElement(LockFilled, null) : React.createElement(UnlockOutlined, null),
                            renderJudgeConnectivityDot(judge)),
                        judge.judge_type === JudgeType.ChiefIn && React.createElement(CrownFilled, null),
                        judge.judge_type === JudgeType.ChiefOut && React.createElement(CrownOutlined, null),
                        judge.judge_type === JudgeType.Observer && React.createElement(EyeOutlined, null)))) : (judge.judge_letter),
                render: (text, item) => (React.createElement(RoundResultValue, { round: round, team: item, judge: judge, judging: judging, showStatistics: showStatistics && RoundItem.isFinalRound(round), states: states }))
            })),
        RoundItem.usesSum(round) ?
            {
                title: _T('round.summaryShort'),
                fixed: 'right',
                dataIndex: 'heats_team_sum',
                render: (text, item) => (React.createElement(Text, { style: { textDecoration: (item.team_disqualified > 0 || item.team_cancelled > 0) ? 'line-through' : undefined }, type: item.team_disqualified > 0 ? "danger" : (item.team_cancelled > 0 ? "warning" : undefined) }, text)),
                responsive: ['md']
            } : {},
        RoundItem.usesPlacement(round) ?
            {
                title: _T('round.placementShort'),
                fixed: 'right',
                dataIndex: 'heats_team_placement',
                render: (text, item) => {
                    const remarkLabel = getRemarkStateLabel(item.heats_team_remark);
                    const remarkHint = getRemarkStateHint(item.heats_team_remark);
                    const content = (React.createElement(Text, { style: { textDecoration: (item.team_disqualified > 0 || item.team_cancelled > 0) ? 'line-through' : undefined }, type: item.team_disqualified > 0 ? "danger" : (item.team_cancelled > 0 ? "warning" : undefined) }, text));
                    return (React.createElement(Space, null,
                        remarkLabel ? (remarkHint ? (React.createElement(Tooltip, { title: remarkHint },
                            React.createElement(Badge, { count: remarkLabel, offset: [15, 0], style: { backgroundColor: token.colorHighlight } }, content))) : (React.createElement(Badge, { count: remarkLabel, offset: [15, 0], style: { backgroundColor: token.colorHighlight } }, content))) : (content),
                        RoundItem.isFinalRound(round) && [RoundStatus.Closed].includes(round.round_status) && item.hasSharedPlacement &&
                            React.createElement(Tooltip, { title: _T('round.sendTeams.through.conflict') },
                                React.createElement(WarningOutlined, { style: { color: token.colorWarning, fontSize: 21 } }))));
                },
            } : {},
        round.round_children > 0 && round.judging_type == JudgingType.Match ?
            {
                title: _T('round.sendTeams.match.column'),
                fixed: 'right',
                width: selectColumnWidth,
                render: (text, item) => (React.createElement(Select, { size: "small", disabled: round.round_status != RoundStatus.Open || disabled, value: item.heats_team_match_id, onChange: (value) => onChangeAttribute(item, value, 'heats_team_match_id'), style: { width: '100%' }, options: [
                        { label: _T('round.sendTeams.notThrough.empty'), value: '0' },
                        ...(childRounds !== null && childRounds !== void 0 ? childRounds : []).map((classRound) => ({
                            label: classRound.round_label,
                            value: classRound.round_id
                        }))
                    ] })),
                responsive: ['md']
            } : {},
        RoundItem.usesPriority(round) && !RoundItem.isPointSummary(round) ?
            {
                title: _T('round.details.priority.label'),
                fixed: 'right',
                width: selectColumnWidth,
                render: (text, item) => {
                    var _a, _b;
                    return (React.createElement(Select, { size: "small", value: (_a = item.heats_team_priority) !== null && _a !== void 0 ? _a : undefined, onChange: (value) => onChangeAttribute(item, value !== null && value !== void 0 ? value : null, 'heats_team_priority'), style: { width: '100%' }, disabled: round.round_status != RoundStatus.Closed || item.team_cancelled > 0 || disabled, options: [
                            { label: _T('common.none'), value: undefined },
                            ...(prioritySettings.type === RoundPriorityType.Groups
                                ? ((_b = prioritySettings.groups) !== null && _b !== void 0 ? _b : []).map((group, index) => {
                                    const foundClass = classes === null || classes === void 0 ? void 0 : classes.find(a => a.class_id === group.class_id);
                                    const targetName = group.name || (foundClass === null || foundClass === void 0 ? void 0 : foundClass.class_label) || (foundClass === null || foundClass === void 0 ? void 0 : foundClass.class_name) || '';
                                    return { label: targetName, value: index };
                                })
                                : [0, 1, 2, 3].map(level => ({
                                    label: level > 0
                                        ? _T('round.details.round_num_alternates.level', { value: level })
                                        : _T('round.details.round_num_alternates.through'),
                                    value: level
                                })))
                        ] }));
                },
                responsive: ['md']
            } : {},
        !RoundItem.isFinalRound(round) &&
            [RoundStatus.Closed, RoundStatus.Confirmed].includes(round.round_status) &&
            (round.round_type === RoundType.Chance || !RoundItem.isChildRound(round)) ?
            [{
                    fixed: 'right',
                    dataIndex: 'heats_team_target_usermodified',
                    render: (text) => (parseInt(text) > 0 &&
                        React.createElement(Tooltip, { title: _T('round.sendTeams.through.modified') },
                            React.createElement("div", { style: { textAlign: 'center' } },
                                React.createElement(WarningOutlined, { style: { color: token.colorWarning, fontSize: 21 } })))),
                },
                (RoundItem.usesPriority(round) ? (prioritySettings.type === RoundPriorityType.Alternates && !RoundItem.isLastRoundInClass(round, rounds)) : true) ?
                    {
                        title: _T('round.sendTeams.through.column'),
                        fixed: 'right',
                        width: selectColumnWidth,
                        render: (text, item) => (React.createElement(Select, { size: "small", value: item.heats_team_target_id, style: { width: '100%' }, onChange: (value) => onChangeAttribute(item, value, 'heats_team_target_id'), disabled: item.heats_team_sent != null || disabled, options: [
                                { label: _T('round.sendTeams.notThrough.empty'), value: '0' },
                                ...(throughRounds !== null && throughRounds !== void 0 ? throughRounds : []).map((classRound) => ({
                                    label: classRound.round_label,
                                    value: classRound.round_id
                                }))
                            ] })),
                        responsive: ['md']
                    } : {}] : {}
    ].flat()
        .filter(column => column && Object.keys(column).length > 0);
    const visibleColumnCount = columns.filter((column) => {
        if (column.hidden) {
            return false;
        }
        if (Array.isArray(column.responsive) && column.responsive.length > 0) {
            return column.responsive.some((breakpoint) => !!screens[breakpoint]);
        }
        return true;
    }).length;
    return (React.createElement(Table, { columns: columns, dataSource: updatedTeams, pagination: false, size: "small", rowKey: "heats_team_id", scroll: { x: "max-content" }, summary: () => heats.indexOf(heat) === heats.length - 1 && round.round_children == 0 && React.createElement(RoundResultFooterSummary, { round: round, judgeColumnOffset: judgeColumnOffset, totalVisibleColumnCount: visibleColumnCount }) }));
};
